import { create } from 'zustand';

import { RadioClickData } from '@/models/radio.click.data';

const CACHE_TTL_MS = 10_000; // 10 sec

interface RadioClicksStoreState {
  cache: RadioClickData[] | null;
  cachedAt: number | null;
  setCache: (data: RadioClickData[]) => void;
  isCacheFresh: () => boolean;
}

export const useRadioClicksStore = create<RadioClicksStoreState>(
  (set, get) => ({
    cache: null,
    cachedAt: null,
    setCache: (data) => set({ cache: data, cachedAt: Date.now() }),
    isCacheFresh: () => {
      const { cachedAt } = get();
      return cachedAt !== null && Date.now() - cachedAt < CACHE_TTL_MS;
    },
  }),
);
